import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

export default function RequireStaff({ children, requireExpert = false }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function checkAccess() {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          navigate('/login');
          return;
        }

        const { data: profile } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', session.user.id)
          .single();

        const allowedRoles = requireExpert 
          ? ['expert', 'admin', 'team']
          : ['admin', 'team'];

        if (profile && allowedRoles.includes(profile.role)) {
          setAuthorized(true);
        } else {
          navigate('/unauthorized');
        }
      } catch (error) {
        console.error('Erreur vérification accès:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    }

    checkAccess();
  }, [navigate, requireExpert]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return authorized ? children : null;
}